import React, { useEffect, useState } from 'react'
import { ChevronRightIcon } from '@chakra-ui/icons'
import { getCompanies } from 'services/api'
import { isSuccessStatus } from 'utils/functions/validations'
import {
  Text,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  Box,
  Avatar,
  Button
} from '@chakra-ui/react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useGlobalContext } from 'providers/GlobalProvider'

interface IChangeCompanyProps {
  isOpen: boolean;
  onClose: () => void;
}

interface IListCompanies {
  businessName: string
  companyId: string
}

const ChangeCompany: React.FC<IChangeCompanyProps> = ({ isOpen, onClose }) => {
  const location = useLocation()
  const { companyName, idSuscriptor, setIdEmpresa, idEmpresa } = useGlobalContext()
  const navigate = useNavigate()
  const [listCompanies, setListCompanies] = useState<IListCompanies[]>([])
  const viewListCompanies =  location.state === 'dashboardNew'
  const numberCompanies = viewListCompanies ? (listCompanies?.length ?? 0) : (listCompanies?.length ?? 0) + 1
  const descriptionNumberCompanies = `Tenés ${numberCompanies} ${numberCompanies <= 1 ? 'suscripta' : 'suscriptas'}`
  const styleAvatar = value => ({
    size:'sm',
    bg: value ? 'primary.500' : 'secondary.60',
    borderColor: value ? 'primary.500' : 'secondary.60',
    color: value ? 'white' : 'secondary.500',
    m:3
  })

  const getDataCompanies = async () => {
    const data = await getCompanies(idSuscriptor)
    if(!isSuccessStatus(data?.status)){
      navigate('/error')
      onClose()
      return null
    }
    return data?.data
  }

  const handleChangeCompany = async companyId => {
    setIdEmpresa(companyId)
    navigate('/dashboard')
    onClose()
  }

  useEffect(() => {
    getDataCompanies().then((response : IListCompanies[]) => {
      const filterCompanies = response?.filter(item => item?.companyId !== idEmpresa)
      setListCompanies(filterCompanies)
    })
  }, [])

  return (
  <Modal isOpen={listCompanies && isOpen} onClose={onClose} size='3xl'>
    <ModalOverlay />
    <ModalContent p='72px 24px 24px 24px'>
      <ModalCloseButton />
      <ModalBody p={0}>
        <Text textStyle='h3' data-testid='changecompany-title'>Cambiar de empresa</Text>
        <Text data-testid='changecompany-description'>{descriptionNumberCompanies}</Text>
        <Box pt='18px'>
          <Box border='solid 1px' borderColor='secondary.60' borderRadius='12px'>
            <Box padding='15px' alignItems='center' display='flex' justifyContent='space-between' data-testid='changecompany-first-item'>
              <Box alignItems='center' display='flex' flexDir='row'>
                <Avatar name={companyName || '- -'} {...styleAvatar(companyName)}/>
                <Box textStyle='h6' data-testid='changecompany-name' color={!companyName && 'neutral.90'} >{companyName || 'Empresa'}</Box>
              </Box>
              <Text>Tu selección actual</Text>
            </Box>
          </Box>
        </Box>
        {
          (viewListCompanies || listCompanies?.length > 0) && (
            <Box pt='18px' textStyle='h3'>
            <Text textStyle='h5' pb={4}>Tus otras empresas</Text>
            <Box border='solid 1px' borderColor='secondary.60' borderRadius='12px'>
              {listCompanies && listCompanies.map(({businessName, companyId}) => (
                <Box padding='15px' alignItems='center' display='flex' justifyContent='space-between' key={companyId} data-testid='changecompany-list'>
                  <Box alignItems='center' display='flex' flexDir='row'>
                    <Avatar name={businessName} {...styleAvatar(businessName)} />
                    <Box textStyle='h6'>{businessName}</Box>
                  </Box>
                  <Button rightIcon={<ChevronRightIcon boxSize={6} />} onClick={() => handleChangeCompany(companyId)} variant='primary-text'>Cambiar</Button>
                </Box>
              ))}
            </Box>
          </Box>
          )
        }
      </ModalBody>
    </ ModalContent>
  </Modal >
)}
export default ChangeCompany
